/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  fixDecoderSize,
  fixEncoderSize,
  getAddressDecoder,
  getAddressEncoder,
  getBytesDecoder,
  getBytesEncoder,
  getStructDecoder,
  getStructEncoder,
  getU16Decoder,
  getU16Encoder,
  type Address,
  type FixedSizeCodec,
  type FixedSizeDecoder,
  type FixedSizeEncoder,
  type ReadonlyUint8Array,
} from '@solana/kit';

export type RehypeBeneficiary = {
  wallet: Address;
  shareBps: number;
  padding: ReadonlyUint8Array;
};

export type RehypeBeneficiaryArgs = RehypeBeneficiary;

export function getRehypeBeneficiaryEncoder(): FixedSizeEncoder<RehypeBeneficiaryArgs> {
  return getStructEncoder([
    ['wallet', getAddressEncoder()],
    ['shareBps', getU16Encoder()],
    ['padding', fixEncoderSize(getBytesEncoder(), 6)],
  ]);
}

export function getRehypeBeneficiaryDecoder(): FixedSizeDecoder<RehypeBeneficiary> {
  return getStructDecoder([
    ['wallet', getAddressDecoder()],
    ['shareBps', getU16Decoder()],
    ['padding', fixDecoderSize(getBytesDecoder(), 6)],
  ]);
}

export function getRehypeBeneficiaryCodec(): FixedSizeCodec<
  RehypeBeneficiaryArgs,
  RehypeBeneficiary
> {
  return combineCodec(
    getRehypeBeneficiaryEncoder(),
    getRehypeBeneficiaryDecoder(),
  );
}
